// src/store/discussionsSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getDiscussionsByProject } from '../../api/ProjectdiscussionApi';

export const fetchDiscussions = createAsyncThunk(
  'discussions/fetchDiscussions',
  async (adminId, { rejectWithValue }) => {
    try {
      const discussionsData = await getDiscussionsByProject(adminId);
      return discussionsData.discussions || [];
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const discussionsSlice = createSlice({
  name: 'discussions',
  initialState: {
    discussions: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchDiscussions.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchDiscussions.fulfilled, (state, action) => {
        state.loading = false;
        state.discussions = action.payload;
      })
      .addCase(fetchDiscussions.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default discussionsSlice.reducer;
